import { Search, Layers, Briefcase, CreditCard } from "lucide-react";
import { Link } from "react-router-dom";

const modules = [
  {
    name: "Diagnostics",
    description: "AI Website, Marketing, and Business Health tools.",
    icon: Search,
    path: "/diagnostics/overview",
    color: "blue",
  },
  {
    name: "Core Website Platform Foundation",
    description: "Manage your website builder and platform essentials.",
    icon: Layers,
    path: "/foundation",
    color: "indigo",
  },
  {
    name: "Recruitment Job Board",
    description: "Post jobs, manage applicants, and track recruitment.",
    icon: Briefcase,
    path: "/job-board/overview",
    color: "emerald",
  },
  {
    name: "Billing & Payment System",
    description: "Handle subscriptions, invoices, and client payments.",
    icon: CreditCard,
    path: "/billing",
    color: "amber",
  },
];

export default function Home() {
  return (
    <div className="min-h-screen pt-10 p-6 md:p-8 lg:p-10 md:ml-0">
      {/* Hero Section */}
      <div className="mb-8 animate-fade-in">
        <div className="rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 p-8 md:p-12 text-white shadow-lg">
          <h1 className="text-4xl md:text-5xl font-bold mb-2">Strivre Services</h1>
          <p className="text-blue-100 text-lg md:text-xl mb-6">
            Overview of all modules in your platform.
          </p>
        </div>
      </div>

      {/* Module Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
        {modules.map((mod, idx) => {
          const Icon = mod.icon;
          const colorClasses: Record<string, string> = {
            blue: "text-blue-600 bg-blue-50 border-blue-200",
            indigo: "text-indigo-600 bg-indigo-50 border-indigo-200",
            emerald: "text-emerald-600 bg-emerald-50 border-emerald-200",
            amber: "text-amber-600 bg-amber-50 border-amber-200",
          };

          return (
            <Link
              key={idx}
              to={mod.path}
              className={`rounded-lg border p-6 bg-white shadow-sm hover:shadow-md transition-all duration-300 hover:border-current animate-slide-in-left`}
              style={{ animationDelay: `${idx * 100}ms` }}
            >
              <div
                className={`inline-flex items-center justify-center w-12 h-12 rounded-lg ${colorClasses[mod.color]} mb-4`}
              >
                <Icon className={`w-6 h-6`} />
              </div>
              <p className="text-lg font-bold text-slate-900 mb-1">{mod.name}</p>
              <p className="text-sm text-slate-600">{mod.description}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
